import { css } from '@emotion/css';
import { computed } from 'vue';
import { useTheme } from '../../../composables/theme';

export const useStyles = () => {
  const theme = useTheme();

  const baseClass = computed(() => css({
    '&, *': {
      margin: 0,
      boxSizing: 'border-box',
    },
    '*': {
      padding: 0,
    },
    background: '#fff',
    padding: '0.25rem 0.5rem',
    cursor: 'pointer',
    borderRadius: '0.25rem',
    fontFamily: theme.value.typography.fontFamily,
    fontSize: '0.813rem',
    fontStyle: 'normal',
    fontWeight: theme.value.typography.fontWeight.regular,
    lineHeight: '1rem',
    color: '#373737',
    marginRight: '2rem',
    '&:hover': {
      background: theme.value.colors.gray.light3,
    },
    '&__label': {
      fontSize: '0.75rem',
      fontStyle: 'normal',
      fontWeight: theme.value.typography.fontWeight.regular,
      color: theme.value.colors.info,
      display: 'inline-block',
      float: 'right',
    },
  }));

  return baseClass;
};
